import { __decorate, __extends } from "tslib";
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { format } from "date-fns";
import { ja } from 'date-fns/locale';
import { DATETIME_FORMAT, SCHEDULE_STATUS_KBN, SCHEDULE_STATUS_CNST } from "@/constants/constants";
var EntryCalendar = /** @class */ (function (_super) {
    __extends(EntryCalendar, _super);
    function EntryCalendar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EntryCalendar.prototype.select = function (scheduleInfo) {
        console.log("select " + JSON.stringify(scheduleInfo));
        if (scheduleInfo.status === SCHEDULE_STATUS_CNST.Possible) {
            return scheduleInfo;
        }
        else {
            return null;
        }
    };
    EntryCalendar.prototype.formatDay = function (day) {
        return format(day, DATETIME_FORMAT.MMDD, { locale: ja });
    };
    EntryCalendar.prototype.formatDayOfWeek = function (day) {
        return format(day, DATETIME_FORMAT.DAY_OF_WEEK, { locale: ja });
    };
    EntryCalendar.prototype.getStatus = function (schedule) {
        return SCHEDULE_STATUS_KBN[schedule.status];
    };
    EntryCalendar.prototype.isFull = function (schedule) {
        return schedule.status === SCHEDULE_STATUS_CNST.Full;
    };
    EntryCalendar.prototype.isPossible = function (schedule) {
        return schedule.status === SCHEDULE_STATUS_CNST.Possible;
    };
    __decorate([
        Prop()
    ], EntryCalendar.prototype, "days", void 0);
    __decorate([
        Prop()
    ], EntryCalendar.prototype, "timeRows", void 0);
    __decorate([
        Emit('select')
    ], EntryCalendar.prototype, "select", null);
    EntryCalendar = __decorate([
        Component({})
    ], EntryCalendar);
    return EntryCalendar;
}(Vue));
export default EntryCalendar;
